import { Configuration, InteractionType, LogLevel } from '@azure/msal-browser';
import { environment } from "./environments/environment";
import { MsalGuardConfiguration } from '@azure/msal-angular';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.msalClientId, // Application (client) ID from Azure portal
    authority: environment.msalAuthority, // 'https://login.microsoftonline.com/4d0b1d13-40fc-479b-870b-9f17bf4b23b6', // Directory (tenant) ID from Azure portal
    redirectUri: environment.appUrl,
    postLogoutRedirectUri: `${environment.appUrl.replace(/\/$/, '')}/sign-out`
  },
  cache: {
    cacheLocation: 'localStorage'
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (level === LogLevel.Error) {
          console.error(message);
        }
        // if (level === LogLevel.Info) { console.info(message); }
        // if (level === LogLevel.Verbose) { console.debug(message); }
        // if (level === LogLevel.Warning) { console.warn(message); }
        // if (level === LogLevel.Error) { alert(`MSAL Error: ${message}`); }
        // if (level === LogLevel.Info) { alert(`MSAL Info: ${message}`); }
        // if (level === LogLevel.Verbose) { alert(`MSAL Verbose: ${message}`); }
        // if (level === LogLevel.Warning) { alert(`MSAL Warning: ${message}`); }
      },
      logLevel: LogLevel.Info
    }
  }
};

// Update the guard config factory to include optional claims
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read'],
      // Request groups and roles claims
      extraQueryParameters: {
        claims: JSON.stringify({
          id_token: {
            groups: null,
            roles: null
          }
        })
      }
    }
  };
}
